module.exports = __webpack_public_path__ + "media/de_de_s3_Liezel.8370f987.oga";